var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"container__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('render-content',{staticClass:"container__content",attrs:{"content":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }